import React from "react";
import { Link } from "react-router-dom";
import { Play, Users, MapPin } from "lucide-react";
import { usePlayer } from "@/lib/player";
import ShareStationButton from "@/components/ShareStationButton";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (u) => !u ? "" : (u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export default function StationCard({ station }) {
  const { tuneIn } = usePlayer();
  return (
    <div className="fl-card overflow-hidden group" data-testid={`station-card-${station.station_id}`}>
      <div className="relative aspect-[4/3] bg-zinc-900 overflow-hidden">
        {station.cover_url ? (
          <img src={resolveImg(station.cover_url)} alt={station.name} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-zinc-800 to-zinc-950" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />

        <ShareStationButton station={station} compact />

        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="fl-mono text-[10px] tracking-[0.25em] uppercase flex items-center gap-1.5 px-2 py-1 rounded-full bg-black/60 border border-white/10 text-red-400">
            <span className="live-dot" /> LIVE
          </span>
          <span className="fl-mono text-[10px] tracking-[0.2em] uppercase px-2 py-1 rounded-full bg-black/60 border border-white/10 text-slate-300">
            {station.genre}
          </span>
        </div>

        <button
          onClick={() => tuneIn(station)}
          aria-label={`Play ${station.name}`}
          className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
          data-testid={`station-play-${station.station_id}`}
        >
          <span className="w-14 h-14 rounded-full bg-emerald-500 text-black flex items-center justify-center shadow-2xl shadow-emerald-500/40">
            <Play className="w-6 h-6 ml-0.5" />
          </span>
        </button>

        <div className="absolute bottom-3 left-3 right-3">
          <Link to={`/s/${station.station_id}`} className="fl-display text-xl font-extrabold tracking-tighter text-white leading-tight line-clamp-2">
            {station.name}
          </Link>
          <div className="mt-1 flex items-center gap-3 text-[11px] fl-mono uppercase tracking-widest text-slate-300">
            <span className="flex items-center gap-1"><MapPin className="w-3 h-3 text-emerald-500" /> {station.country}</span>
            <span className="flex items-center gap-1"><Users className="w-3 h-3 text-emerald-500" /> {station.listener_count || 0}</span>
          </div>
        </div>
      </div>
      {station.tagline ? (
        <div className="px-4 py-3 text-sm text-slate-400 line-clamp-2">{station.tagline}</div>
      ) : null}
    </div>
  );
}
